<template>
  <my-giving-layout>
    <div class="w-full min-h-screen bg-[#F6F4F0]">
      <BackButton class="w-full px-[20px] mb-[16px]" :customBack="back" />
      <div class="px-[20px] md:px-[24px] lg:px-[28px] pb-[64px]">
        <div class="flex flex-col mb-[32px]">
          <div class="flex flex-row justify-between">
            <div
              class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem]"
            >
              Giving to
            </div>
            <div
              class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] font-bold"
            >
              {{ selectedGiveType }}
            </div>
          </div>
          <div class="flex flex-row justify-between pt-[8px]">
            <div
              class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem]"
            >
              Giving method
            </div>
            <div
              class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] font-bold"
            >
              Overseas Bank Transfer
            </div>
          </div>
        </div>
        <div class="flex flex-col rounded-[16px] bg-[#E5E2DF] p-[16px] mb-[24px]">
          <p
            class="text-[1.5rem] md:text-[2rem] lg:text-[2.25rem] leading-[2rem] md:leading-[2.5rem] lg:leading-[2.75rem] font-bold mb-[24px]"
          >
            Instructions
          </p>
          <p
            class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] mb-[8px]"
          >
            Name: <b>Heart of God Church</b>
            <svg
              class="inline ml-[8px] cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="copyClipboard('ovs-copiedText1', 'Heart of God Church')"
            >
              <path
                d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              id="ovs-copiedText1"
              class="text-[0.75rem] leading-[1.25rem] text-[#0D5DF5] hidden"
            >
              Copied
            </span>
          </p>
          <p
            class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] mb-[8px]"
          >
            Account: <b>1000006671</b>
            <svg
              class="inline ml-[8px] cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="copyClipboard('ovs-copiedText2', '1000006671')"
            >
              <path
                d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              id="ovs-copiedText2"
              class="text-[0.75rem] leading-[1.25rem] text-[#0D5DF5] hidden"
            >
              Copied
            </span>
          </p>
          <p
            class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] mb-[8px]"
          >
            Bank Name: <b>DBS Bank Ltd</b>
            <svg
              class="inline ml-[8px] cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="copyClipboard('ovs-copiedText3', 'DBS Bank Ltd')"
            >
              <path
                d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              id="ovs-copiedText3"
              class="text-[0.75rem] leading-[1.25rem] text-[#0D5DF5] hidden"
            >
              Copied
            </span>
          </p>
          <p
            class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] mb-[8px]"
          >
            Bank Code: <b>7171</b>
            <svg
              class="inline ml-[8px] cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="copyClipboard('ovs-copiedText4', '7171')"
            >
              <path
                d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              id="ovs-copiedText4"
              class="text-[0.75rem] leading-[1.25rem] text-[#0D5DF5] hidden"
            >
              Copied
            </span>
          </p>
          <p
            class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] mb-[8px]"
          >
            Branch Code: <b>100</b>
            <svg
              class="inline ml-[8px] cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="copyClipboard('ovs-copiedText5', '100')"
            >
              <path
                d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              id="ovs-copiedText5"
              class="text-[0.75rem] leading-[1.25rem] text-[#0D5DF5] hidden"
            >
              Copied
            </span>
          </p>
          <p class="text-[1rem] leading-[1.25rem] mb-[16px]">
            Swift Code: <b>DBSSSGSG</b>
            <svg
              class="inline ml-[8px] cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="copyClipboard('ovs-copiedText6', 'DBSSSGSG')"
            >
              <path
                d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              id="ovs-copiedText6"
              class="text-[0.75rem] leading-[1.25rem] text-[#0D5DF5] hidden"
            >
              Copied
            </span>
          </p>
          <p
            class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] mb-[16px]"
          >
            Bank Address:<br />
            <b
              >12 Marina Boulevard, DBS Asia Central, Marina Bay Financial Centre Tower 3, Singapore
              018982</b
            >
            <svg
              class="inline ml-[8px] cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="
                copyClipboard(
                  'ovs-copiedText7',
                  '12 Marina Boulevard, DBS Asia Central, Marina Bay Financial Centre Tower 3, Singapore 018982',
                )
              "
            >
              <path
                d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
                stroke="#0D5DF5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              id="ovs-copiedText7"
              class="text-[0.75rem] leading-[1.25rem] text-[#0D5DF5] hidden"
            >
              Copied
            </span>
          </p>
          <p
            class="italic text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.5rem] md:leading-[2rem] lg:leading-[2.25rem]"
          >
            *DBS Bank does not have an IBAN, Routing Number or Sort Code.
          </p>
        </div>
        <div
          class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] pb-[8px]"
        >
          <p>Do indicate the purpose of giving under the “transaction reference” field:</p>
          <ul class="list-disc ml-4">
            <li>Your Name</li>
            <li>Purpose of Giving</li>
          </ul>
        </div>
        <BottomButton
          id="back"
          text="Back to MyGiving"
          :disabled="loading"
          @click="handleBack"
          class="w-full my-[32px]"
        />
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import MasterLayout from '@/components/MasterLayout.vue';
import BackButton from '@/components/common/BackButton.vue';
import BottomButton from '@/components/common/BottomButton.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';
import { mapState } from 'vuex';
export default {
  components: {
    MasterLayout,
    BackButton,
    BottomButton,
    MyGivingLayout,
  },
  computed: {
    ...mapState('myGiving', ['selectedGiveType']),
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace('/my-giving');
      }
    },
    copyClipboard(id, target) {
      const element = document.getElementById(id);
      element.innerText = 'Copied';
      navigator.clipboard.writeText(target);
      setTimeout(() => this.removeCopyText(id), 1500);
    },
    removeCopyText(id) {
      const element = document.getElementById(id);
      element.innerText = 'Copy';
    },
    handleBack() {
      this.$router.replace('/my-giving');
    },
  },
};
</script>
